'use strict';

module.exports = {
  groups: {
    RMA: 'RMA',
    FOOD: 'FOOD',
    MULO: 'MULO',
  },
};
